var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Dashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M17,18H11a1,1,0,0,1-1-1V9a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v8A1,1,0,0,1,17,18Zm-5-8v6h4V10ZM7,18H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H7A1,1,0,0,1,8,1V17A1,1,0,0,1,7,18ZM2,2V16H6V2ZM17,6H11a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1V5A1,1,0,0,1,17,6ZM12,2V4h4V2Z",
    transform: "translate(3 3)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Dashboard);
export default __webpack_public_path__ + "static/media/icon-24-dashboard.7f4ecec0cb66d665adcbe56ea5469c79.svg";
export { ForwardRef as ReactComponent };